module.exports = __webpack_public_path__ + "static/bg_0919.6ea506df.png";